<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps({
  number: {
    type: Number,
    required: true,
  },
});

const odometerArray = ref([props.number - 1, props.number, props.number + 1]);
const currentNumber = ref(props.number);

const changeOdometer = () => {
  if (currentNumber.value === props.number) return

  if (Math.abs(currentNumber.value - props.number) === 1) {
    if (props.number > currentNumber.value) {
      odometerArray.value.push(props.number + 1);
      odometerArray.value.shift();
    } else {
      odometerArray.value.splice(0, 0, props.number - 1);
      odometerArray.value.pop();
    }
  } else {
    odometerArray.value = [props.number - 1, props.number, props.number + 1];
  }
  currentNumber.value = props.number;
}

watch(
  () => props.number,
  () => {
    changeOdometer()
  },
)
</script>

<template>
  <ul class="odometer flex flex-col list-unstyled overflow-hidden relative mb-0 h-100 top-0 left-0">
    <li
      v-for="(item, key) in odometerArray"
      :key="item"
      class="text-center w-100 text-center h-100 flex items-center justify-center"
      :class="[{ 'prev absolute': key < 1 }, { 'next absolute': key > 1 }]"
    >
      {{ item }}
    </li>
  </ul>
</template>

<style lang="scss">
.odometer {
    li {
        transition: .2s all linear;
        transform: translateY(0%);

        &.prev { transform: translateY(-100%); }
        &.next { transform: translateY(100%); }
    }
}
</style>
